import { IJwtSignIn, IUser } from '@ftd/types'

import { BASE_URL } from '@/api/constants'
import { secureFetch } from '@/api/secure-fetch'

export const apiCreateUser = async (data: Partial<IUser>): Promise<IJwtSignIn> => {
  const res = await fetch(`${BASE_URL}/users`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })
  if (!res.ok) throw new Error('Failed to create user')
  return res.json()
}

export const apiUpdateUser = async (id: string, data: Partial<IUser>): Promise<IUser> => {
  const res = await secureFetch(`${BASE_URL}/users/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(data),
  })
  if (!res.ok) throw new Error('Failed to update user')
  return res.json()
}

export const apiRequestPasswordChange = async (email: string): Promise<void> => {
  const res = await secureFetch(`${BASE_URL}/users/forgot-password`, {
    method: 'POST',
    body: JSON.stringify({ email }),
  })
  if (!res.ok) throw new Error('Failed to request password change')
  return res.json()
}

export const apiSetNewPassword = async (newPassword: string, passwordResetToken: string): Promise<void> => {
  const res = await secureFetch(`${BASE_URL}/users/reset-password`, {
    method: 'POST',
    body: JSON.stringify({
      newPassword,
      passwordResetToken,
    }),
  })
  if (!res.ok) throw new Error('Failed to set new password')
  return res.json()
}

export const apiResetPassword = async (newPassword: string, passwordResetToken: string): Promise<any> => {
  const res = await fetch(`${BASE_URL}/users/reset-password`, {
    method: 'POST',
    body: JSON.stringify({ newPassword, passwordResetToken }),
    headers: {
      'Content-Type': 'application/json',
    },
  })
  if (!res.ok) return Promise.reject(new Error('Failed to reset password'))
  return res.json()
}

export const apiForgotPassword = async (email: string): Promise<void> => {
  const res = await fetch(`${BASE_URL}/users/forgot-password`, {
    method: 'POST',
    body: JSON.stringify({ email }),
    headers: {
      'Content-Type': 'application/json',
    },
  })
  if (!res.ok) throw new Error('Failed to send forgot password email')
  return res.json()
}
